import App, { removeServiceTemplateId } from '@/Common/Runtime/AppsCollector/App';
import { $bus } from '@/HostApp/services/Bus';
import AppView from '@/Framework/app/components/ApplicationView/AppView.vue';

class AppsCollector {
	private apps: Common.IMap<App> = {};

	constructor() {
		$bus.$on('apps-collector-apply', this.onApply.bind(this));
		$bus.$on('apps-collector-set-component', this.onSetComponent.bind(this));
		$bus.$on('apps-collector-emit-notifications', this.onEmitNotifications.bind(this));
	}

	protected onEmitNotifications({ message }: { message: APS.INotification }): void {
		const apps = this.getApps();
		Object.values(apps).forEach((app) => app.emitNotification(message));
	}

	protected onApply({ id, method, args }: { id: string; method: string; args: APS.ICustomData }): void {
		this.apply(id, method, args);
	}

	protected apply(id: string = '', functionName: string, args: APS.ICustomData): boolean {
		const [appId, viewId] = id.split('#');
		const app = this.getApp(appId);

		if (app && viewId) {
			return app.apply(viewId, functionName, args);
		} else {
			return false;
		}
	}

	public add(id: string, el: Host.WCElement): App {
		return (this.apps[id] = new App(id, el));
	}

	public getApps(): Common.IMap<App> {
		return this.apps;
	}

	public getApp(id: string): App | null {
		return this.apps[id] || null;
	}

	private onSetComponent({ appId, viewId, component }: { appId: string; viewId: string; component: AppView }): void {
		const app = this.getApp(`vue_${appId}`);

		// fix for OA-34602, remove serviceTemplateId from view.id
		viewId = removeServiceTemplateId(viewId).viewId;

		const view = app && app.views[viewId];
		view && view.setComponent(component);
	}
}

const appsCollector = new AppsCollector();

export default appsCollector;
